import ViewBookPage from './ViewBookPage'
export default ViewBookPage;